import { Trans } from "react-i18next";
import React from "react";
import { Outlet, Link as RouterLink } from "react-router-dom";
import { Box, Link, useTheme, useMediaQuery } from "@mui/material";
import PublicNavbar from "./PublicNavbar";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import { useAuth } from "./AuthContext";

function UnifiedLayout() {
  const { currentUser } = useAuth();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isLoggedIn = !!currentUser;

  return (
    <Box>
      <PublicNavbar />

      {/* Beta Banner is always visible */}
      <Box
        sx={{
          bgcolor: "warning.light",
          color: "black",
          px: 2,
          py: 1,
          textAlign: "center",
          fontWeight: 500,
          marginTop: "64px", // Offset for the fixed navbar
        }}
      >
        <Trans
          i18nKey="banner.beta"
          components={{
            1: <strong />,
            2: (
              <Link
                component={RouterLink}
                to="/contact"
                sx={{ color: "inherit", fontWeight: "bold" }}
              />
            ),
          }}
        />
      </Box>

      <Box sx={{ display: "flex" }}>
        {/* Only show Sidebar when logged in AND not on mobile */}
        {isLoggedIn && !isMobile && <Sidebar />}

        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 3,
            bgcolor: "#fff",
            marginTop: 0,
            // Only add left margin when sidebar is visible (logged in + desktop)
            marginLeft: isLoggedIn && !isMobile ? "240px" : 0,
            height: "calc(100vh - 110px)",
            overflowY: "auto",
            pb: "80px",
          }}
        >
          <Outlet />
        </Box>
      </Box>
      <Footer />
    </Box>
  );
}

export default UnifiedLayout;
